// extracted by mini-css-extract-plugin
module.exports = {"tabBar":"TabBarNew_tabBar__PhL4N"};